<template>
    <DForm @submit.prevent="submitForm">
        <div
            v-for="(translation, key) in translations"
            :key="key"
        >
            <DCard
                padding
                :title="defaultLanguageLabel(translation)"
                class="mb-3"
            >
                <DFormRow
                    :label="__('settings.tax_exemptions.form.invoice_text')"
                    :is-required="true"
                    :hint="__('settings.tax_exemptions.form.invoice_text_hint')"
                >
                    <DInput
                        id="invoice_text"
                        v-model="form.translations[key].invoice_text.value"
                        add-label-classes="required"
                        maxlength="255"
                    />
                    <DAlert
                        v-if="errors && errors.invoice_text"
                        color="danger"
                        class="mt-2"
                    >
                        {{ errors.invoice_text }}
                    </DAlert>
                </DFormRow>
            </DCard>
        </div>
        <DFormControls
            :cancel-route="$route('settings.tax-exemption.index')"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    taxExemption: {
        type: Object,
        default: () => {
            return {}
        }
    },
    translations: {
        type: Object,
        default: () => {
            return {}
        }
    },
    defaultTenantLanguage: {
        type: String,
        default: ''
    }
})

const form = useForm({
    translations: props.translations
})

const submitForm = () => {
    form.post(route('settings.tax-exemption.translations-update', { taxExemption: props.taxExemption.id ?? 0 }))
}

const defaultLanguageLabel = (translation) => props.defaultTenantLanguage.value === translation.language.value ? `${__('settings.default_customer_language')} ${translation.language.label}` : translation.language.label

</script>

<style scoped lang="scss">

</style>
